var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.$accessor.gpxTracks.allGpxTracks),function(track){return [_c('l-gpx',{key:track.id,attrs:{"gpx-file":track.gpx,"visible":track.visible,"gpx-options":_vm.gpxOptions(track)}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }